import script from "./ZeroItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ZeroItem.vue?vue&type=script&lang=ts&setup=true"

import "./ZeroItem.vue?vue&type=style&index=0&id=6c530c7c&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c530c7c"]])

export default __exports__